import { Global } from "@emotion/react";
import { GlobalStyles as TWGlobalStyles } from "twin.macro";
import customGlobalStyles from "../../styles/global";
import "@esri/calcite-components/dist/calcite/calcite.css";

const GlobalStyles = () => {
  return (
    <>
      <TWGlobalStyles />
      <Global styles={customGlobalStyles} />
    </>
  );
};

export default GlobalStyles;
